module.exports = __webpack_public_path__ + "img/turanza_all_seazon6.d1cb47cd.png";